import { createApp } from "vue";
import { createPinia } from 'pinia'
import DashboardLayout from "./components/DashboardLayout.vue";
import EmptyLayout from "./components/EmptyLayout.vue";
import VueFeather from 'vue-feather';
import "./assets/tailwind.css";
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import App from "./App.vue";
import router from "./router";
import { defaultConfig, plugin } from "@formkit/vue";
import config from "../formkit.config";
import ApiService from "@/_services/api.service";
import PrimeVue from "primevue/config";
import InlineSvg from "vue-inline-svg";
import PrimeVueComponents from '@/plugins/primevue';
import ConfirmationService from 'primevue/confirmationservice';
import { createI18n } from "vue-i18n";
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import * as Sentry from "@sentry/vue";

// import translations
import fr from "./locales/fr.json";
import en from "./locales/en.json";

// configure i18n
const i18n = createI18n({
    locale: "fr",
    fallbackLocale: "fr",
    messages: { fr, en },
    legacy: false
  });

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate);

// create and start the app
const app = createApp(App);
app.use(router);
app.use(i18n);
app.use(pinia);
app.use(plugin, defaultConfig(config));
app.use(PrimeVue, {
          locale: {
            contains: 'Contient',
            notContains: 'Ne contient pas',
            startsWith: 'Commence par',
            endsWith: 'Fini par',
            equals: 'Égal',
            notEquals: 'Différent',
            noFilter: 'Pas de filtre',
        },
    }
);
app.use(ToastService);

app.use(ConfirmationService);
// eslint-disable-next-line vue/multi-word-component-names
app.component('Toast', Toast);

Sentry.init({
    app,
    dsn: "https://9ceb5778e85c332da22c8ceeab1a477d@sentry.club-employes.com/2"
});

ApiService.init(app);

app.mount("#app");


app.component("default-layout", DashboardLayout);
app.component("empty-layout", EmptyLayout);
app.component(VueFeather.name, VueFeather);
app.component('inline-svg', InlineSvg);
app.use(PrimeVueComponents);



